import { Capacitor } from '@capacitor/core';

export const WEB_SCREEN_BREAKPOINT = 1000;

export const MOBILE_SCREEN_UTILS = {
  isMobileScreen() {
    return Capacitor.isNativePlatform() || window.innerWidth <= 640;
  },

  isTabletScreen() {
    return Capacitor.isNativePlatform() || window.innerWidth < WEB_SCREEN_BREAKPOINT;
  },
};
